export class SearchCondition {
  course_code: string = ""
  course_type: string = ""
  name: string = ""
  grade: string = ""
}

export class Course {
  id: number
  course_code: number
  course_type: number
  name: string
  grade: number

  constructor(x: any){
    this.id = x.id;
    this.course_code = x.course_code;
    this.course_type = x.course_type;
    this.name = x.name;
    this.grade = x.grade;
  }
}